import React from 'react';

import Product from './components/Product';

function App() {
  return (
    <div className='App'>
      <Product />
    </div>
  );
}

export default App;
